import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const DEFAULT_NAV_MENU = {
  en: {},
};

export const navMenu = createSlice({
  name: "navMenu",
  initialState: DEFAULT_NAV_MENU,
  reducers: {
    setNavMenuKeys: (state, action) => {
      return {
        ...state,
        ...action.payload,
        updatedTime: new Date().toISOString(), // ToDo: Need to move this on setNavMenuKeys function call
      };
    },
  },
});

export const { setNavMenuKeys } = navMenu.actions;

export const useNavMenuKeys = () => useSelector((state: any) => state.navMenu);

export default navMenu.reducer;
